import * as joint from '@joint/plus';

export default class TriController {
  static createTri(service) {
    const defaultPorts = [
      { id: 'port1', group: 'auto', time: 0, source: null, destination: null },
      { id: 'port2', group: 'auto', time: 0, source: null, destination: null },
      { id: 'port3', group: 'auto', time: 0, source: null, destination: null },
      { id: 'port4', group: 'auto', time: 0, source: null, destination: null },
    ];

    const tri = new joint.shapes.standard.Rectangle({
      type: 'appShapes.Tri',
      position: { x: 100, y: 100 },
      size: { width: 200, height: 100 },
      attrs: {
        body: { fill: '#ffffff', stroke: '#000000', strokeWidth: 2, rx: 40, ry: 40 },
        label: { text: 'TRI', fill: '#000000' },
      },
      ports: {
        groups: {
          auto: {
            position: { name: 'perimeter' },
            attrs: {
              portBody: { magnet: true, stroke: '#000', fill: '#FFF', r: 5 },
            },
            label: { position: { name: 'inside' } },
          },
        },
        items: defaultPorts,
      },
    });

    const current = tri.get('ports/items');
    if (!current || !current.length) {
      tri.prop('ports/items', defaultPorts, { rewrite: true });
    }
    return tri;
  }

  static handleElementSelect(service, cellView) {
    const cell = cellView.model;
    if (cell.get('type') === 'appShapes.Tri') {
      console.log(cell.getPorts());
    }
  }

  static updateTriPorts(service, triElement, newPorts) {
    const prev = triElement.get('ports/items') || [];
    try {
      triElement.prop('ports/items', newPorts, { rewrite: true, silent: false });
      triElement.trigger('change:ports', triElement, newPorts);
    } catch (err) {
      triElement.prop('ports/items', prev, { rewrite: true });
    }
  }
}
